import { axios, createFormData, handleError } from '../axios';

export const memberValidationPasswordRecoveryCode = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post('member/account/forgotten/code', createFormData(data))
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
          reject();
        }
      })
      .catch((e) => {
        handleError(e);
        reject();
      });
  });
};
